/*
Definiton of global variables for the logic part
*/

// The general API endpoint for all requests
export var API_ENDPOINT = "https://api.schmuckli.cloud";

// Updates the API endpoint
var updateAPIEndpoint = function (new_api_point) {
    API_ENDPOINT = new_api_point;
};
export default updateAPIEndpoint;